import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';

import useQueryParameters from '../../hooks/use_query_parameters';
import useTranslation from '../../hooks/use_translation';

const ProductToggleListType = ({ className }) => {
	const { queryParameters, setQueryParameter } = useQueryParameters();
	const { t } = useTranslation('component_test_product_toggle_list_type');

	const [isSlim, setIsSlim] = useState(queryParameters?.list_type === 'slim');

	const handleToggle = () => {
		const newType = isSlim ? 'list' : 'slim';
		setIsSlim(!isSlim);
		setQueryParameter('list_type', newType);
	};

	useEffect(() => {
		setIsSlim(queryParameters?.list_type === 'slim');
	}, [queryParameters?.list_type]);

	return (
		<div className={className}>
			<div className="form-check form-switch">
				<label className="form-check-label" htmlFor="toggleListType">
					{t('t1')}
				</label>
				<input
					checked={isSlim}
					className="form-check-input"
					id="toggleListType"
					onChange={handleToggle}
					role="switch"
					type="checkbox"
				/>
			</div>
		</div>
	);
};

ProductToggleListType.propTypes = {
	className: PropTypes.string,
};

export default ProductToggleListType;
